import { PurchaseOrderDeliveryFormik } from "../PurchaseOrderDeliveryFormik";
import { PurchaseOrderDeliveryGetMinDto } from "../PurchaseOrderDeliveryGetMinDto";

export const purchaseOrderDeliveryGetMinToFormik = (
  item: PurchaseOrderDeliveryGetMinDto
): PurchaseOrderDeliveryFormik => ({
  driverFirstName: item?.driverFirstName || '',
  driverLastName: item?.driverLastName || '',
  eta: item?.eta || null,
  truckPlate: item?.truckPlate || '',
  orderId: item?.orderId || '',
  timeSlot: item?.timeSlot || null,
  logisticsCompany: item?.logisticsCompany || '',
  contacts: item?.contacts || '',
  cmrNumber: item?.cmrNumber || '',
  cmrDate: item?.cmrDate || null,
  loadingReference: item?.loadingReference || '',
  warehouseId: item?.warehouseId || '',
});